import { AxiosInstance } from "axios"
import {
    BillReceiversItem,
    PrivateCompanyBillReceiver,
    PrivatePersonBillReceiver,
    PublicInstitutionBillReceiver,
} from "./billReceiversTypes"

export enum BillReceiversQuery {
    LIST = "bill-receivers-for-company",
}

export type AccountingBillReceiversParams = Readonly<{
    companyId: number
    search?: string
}>

export type AccountingBillReceiversResponse = Readonly<{
    billReceivers: BillReceiversItem[]
}>

export async function fetchAccountingBillReceivers(
    { companyId, search }: AccountingBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AccountingBillReceiversResponse> {
    const url = `/companies/${companyId}/accounting/billReceivers`
    const { data } = await axios.get(url, {
        signal,
        params: {
            search,
        },
    })

    return data
}

export type CreateBillReceiversParams = Readonly<{
    billReceiver?: PrivatePersonBillReceiver | PublicInstitutionBillReceiver | PrivateCompanyBillReceiver
}>

type CreateBillReceiversResponse = Readonly<{
    billReceiver: BillReceiversItem
}>

export async function createBillReceivers(
    { billReceiver }: CreateBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CreateBillReceiversResponse> {
    const url = "/billReceivers"
    const { data } = await axios.post(
        url,
        {
            ...billReceiver,
        },
        {
            signal,
        },
    )

    return data
}
